import React, { useEffect, useState } from 'react'
import Container from '../../base/Container'
import LoadingContainer from '../../controls/LoadingContainer'
import { useToast } from '../../controls/Toast/ToastService'
import { CiLocationArrow1 } from "react-icons/ci";
import Empty from '../../controls/Empty'
import Card from '../../controls/Card'
import {
    MdErrorOutline,
    MdSearch,
    MdOutlineHistory,
    MdOutlineCalendarMonth,
    MdOutlineCurrencyRupee,
    MdOutlineStickyNote2,
    MdOutlineReceiptLong,
    MdOutlinePayments,
    MdOutlinePerson,
    MdOutlinePhone,
} from 'react-icons/md'
import * as rechargeHistoryCrud from '../../../configurations/crud/rechargeHistoryCrud'
import Paging from '../../controls/Paging'
import { PAGE_SIZE } from '../../../configurations/initUrls';
import { EBoolBg, GetEBoolName } from '../../../configurations/enums/EBool';
import StatusContainer from '../../controls/StatusContainer';
import { Link, useParams } from 'react-router-dom';
import Input from '../../controls/Input';
import useDebounce from '../../../configurations/commonlib/useDebounce';
import moment from 'moment';
import { ERechargeHistoryStatusBg, GetERechargeHistoryStatusName } from '../../../configurations/enums/ERechargeHstoryStatus';
import useGlobalLoader from '../../../configurations/useGlobalLoader';



export default function GetAllByUser() {
    const initValues = {
        PageNo: 1,
        PageSize: PAGE_SIZE,
        SearchTerm: "",
    }
    const { start, end } = useGlobalLoader()
    const toast = useToast()
    const [loding, setLoding] = useState(false)
    const [lodingCrud, setLodingCrud] = useState(false)
    const [userData, setUserData] = useState([]);
    const [search, setSearch] = useState(initValues);
    const [LastPage, setLastPage] = useState(1);
    const [pagingData, setPagingData] = useState();
    const [searchTerm, setSearchTerm] = useState("");
    const [searchDebounce, setSearchDebounce] = useDebounce("", 700);

    useEffect(() => {
        setSearchDebounce(searchTerm)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchTerm])

    useEffect(() => {
        onSearch()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchDebounce])

    const OnPageChange = (e) => {
        setSearch({ ...search, PageNo: e })
        onSearchNew({
            PageNo: e,
            PageSize: search.PageSize,
            SearchTerm: search.SearchTerm
        })
    }
    const onSearchChange = (e) => {
        setSearchTerm(e.target.value)
    }
    const onSearch = () => {
        onSearchNew({
            PageNo: 1,
            PageSize: search.PageSize,
            SearchTerm: searchTerm
        })
    }
    const onSearchNew = (search) => {
        getAllByUserr(search)
    }

    const doRefresh = () => {
        setSearch({ ...search, PageNo: 1 })
        onSearchNew({
            PageNo: 1,
            PageSize: search.PageSize,
            SearchTerm: search.SearchTerm
        })
    }

    const getAllByUserr = (params) => {
        setLoding(true)
        start()
        rechargeHistoryCrud.GetAllByUser(params).then(res => {
            let mdata = res.data
            if (mdata.result.succeeded) {
                setUserData(mdata.data)
                setPagingData(mdata.paging)
                setLastPage(mdata.paging.pageCount)
            } else {
                setPagingData()
                setLastPage(1)
                setUserData([])
                toast.open(mdata.result.message, <MdErrorOutline />, "danger")
            }
            setLoding(false)
            end()
        }).catch(errors => {
            setPagingData()
            setLastPage(1)
            setUserData([])
            setLoding(false)
            end()
            toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
        })
    }

    return (
        <Container title={"Recharge History"}>
            <div className="w-full px-2 sm:px-4">
                <Card
                    isUser={true}
                    isBorder={true}
                    isRefresh={true}
                    doRefresh={doRefresh}
                    title={
                        <div className="flex w-full items-center gap-2">
                            <span className="grid h-8 w-8 shrink-0 place-items-center rounded-lg bg-brand-500 text-white shadow-sm">
                                <MdOutlineHistory className="text-base" />
                            </span>
                            <div className="min-w-0 leading-tight">
                                <span className="block truncate">Recharge History</span>
                                {pagingData &&
                                    <span className="block truncate text-xs font-normal text-gray-500">
                                        {pagingData.totalCount ?? ""} recharge{pagingData.totalCount == 1 ? "" : "s"}
                                    </span>
                                }
                            </div>
                        </div>
                    }
                >
                    <div className="flex flex-col">
                        <div className="py-3">
                            <Input
                                Icon={<MdSearch className="text-lg text-gray-400" />}
                                onChange={onSearchChange}
                                placeholder="Search Recharge History"
                            ></Input>
                        </div>
                        <Paging LastPage={LastPage} CurrentPage={search.PageNo} OnPageChange={OnPageChange} pagingData={pagingData}>
                            {!loding ? (
                                userData.length > 0 ? (
                                    <>
                                        {/* ===== desktop table ===== */}
                                        <div className="hidden overflow-x-auto rounded-xl ring-1 ring-gray-100 lg:block">
                                            <table className="w-full border-collapse text-left text-sm text-gray-500 rtl:text-right">
                                                <thead>
                                                    <tr className="bg-gray-100 text-xs uppercase tracking-wide text-gray-500">
                                                        <th scope="col" className="px-3 py-3 font-semibold">#</th>
                                                        <th scope="col" className="px-3 py-3 font-semibold">
                                                            <span className="flex items-center gap-1"><MdOutlineCalendarMonth className="text-sm" /> Created On</span>
                                                        </th>
                                                        <th scope="col" className="px-3 py-3 font-semibold">
                                                            <span className="flex items-center gap-1"><MdOutlineCurrencyRupee className="text-sm" /> Count/Price</span>
                                                        </th>
                                                        <th scope="col" className="px-3 py-3 font-semibold">Note</th>
                                                        <th scope="col" className="px-3 py-3 font-semibold">
                                                            <span className="flex items-center gap-1"><MdOutlineReceiptLong className="text-sm" /> Order No</span>
                                                        </th>
                                                        <th scope="col" className="px-3 py-3 font-semibold">
                                                            <span className="flex items-center gap-1"><MdOutlinePayments className="text-sm" /> Pay No</span>
                                                        </th>
                                                        <th scope="col" className="px-3 py-3 font-semibold">Pay Details</th>
                                                        <th scope="col" className="px-3 py-3 font-semibold">
                                                            <span className="flex items-center gap-1"><MdOutlinePerson className="text-sm" /> Contact</span>
                                                        </th>
                                                        <th scope="col" className="px-3 py-3 font-semibold">Status</th>
                                                    </tr>
                                                </thead>
                                                <tbody className="divide-y divide-gray-100">
                                                    {userData.map((item, index) => (
                                                        <tr key={item.id ?? index} className="bg-white hover:bg-gray-50">
                                                            <td className="text-nowrap px-3 py-2 text-gray-500">{item.id}</td>
                                                            <td className="text-nowrap px-3 py-2">{moment(item.createdOn).format('DD/MM/YYYY hh:mm A')}</td>
                                                            <td className="text-nowrap px-3 py-2 font-medium text-gray-800">
                                                                {item.opdCount} at ₹ {item.amount.toFixed(2)}
                                                            </td>
                                                            <td className="max-w-[180px] truncate px-3 py-2" title={item.note}>{item.note}</td>
                                                            <td className="text-nowrap px-3 py-2">{item.paymentOrderNo}</td>
                                                            <td className="text-nowrap px-3 py-2">{item.paymentNo}</td>
                                                            <td className="max-w-[160px] truncate px-3 py-2" title={item.paymentDetails}>{item.paymentDetails}</td>
                                                            <td className="text-nowrap px-3 py-2">
                                                                <div className="leading-tight">
                                                                    <div>{item.rechargeContactName}</div>
                                                                    <div className="text-xs text-gray-400">{item.rechargeContactNo}</div>
                                                                </div>
                                                            </td>
                                                            <td className="text-nowrap px-3 py-2">
                                                                <StatusContainer
                                                                    bg={ERechargeHistoryStatusBg(item.status)}
                                                                    text={GetERechargeHistoryStatusName(item.status)}
                                                                />
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>

                                        {/* ===== mobile / tablet cards ===== */}
                                        <div className="space-y-2 lg:hidden">
                                            {userData.map((item, index) => (
                                                <div key={item.id ?? index} className="rounded-xl border border-gray-100 bg-white p-3 shadow-sm">
                                                    {/* top row: amount + status */}
                                                    <div className="flex items-start justify-between gap-2">
                                                        <div className="min-w-0">
                                                            <div className="flex items-center gap-1 font-semibold text-gray-800">
                                                                <MdOutlineCurrencyRupee className="text-base text-brand-500" />
                                                                {item.amount.toFixed(2)}
                                                                <span className="text-xs font-normal text-gray-400">· {item.opdCount} OPD</span>
                                                            </div>
                                                            <div className="mt-0.5 flex items-center gap-1 text-xs text-gray-400">
                                                                <MdOutlineCalendarMonth className="text-sm" />
                                                                {moment(item.createdOn).format('DD/MM/YYYY hh:mm A')}
                                                                <span>· #{item.id}</span>
                                                            </div>
                                                        </div>
                                                        <div className="shrink-0">
                                                            <StatusContainer
                                                                bg={ERechargeHistoryStatusBg(item.status)}
                                                                text={GetERechargeHistoryStatusName(item.status)}
                                                            />
                                                        </div>
                                                    </div>

                                                    {/* details */}
                                                    <div className="mt-2 grid grid-cols-1 gap-x-4 gap-y-1 border-t border-gray-50 pt-2 text-xs xs:grid-cols-2">
                                                        {item.note &&
                                                            <div className="flex items-start gap-1 text-gray-600">
                                                                <MdOutlineStickyNote2 className="mt-0.5 shrink-0 text-sm text-gray-400" />
                                                                <span className="break-words">{item.note}</span>
                                                            </div>
                                                        }
                                                        {item.paymentOrderNo &&
                                                            <div className="flex items-start gap-1 text-gray-600">
                                                                <MdOutlineReceiptLong className="mt-0.5 shrink-0 text-sm text-gray-400" />
                                                                <span className="break-all">Order: {item.paymentOrderNo}</span>
                                                            </div>
                                                        }
                                                        {item.paymentNo &&
                                                            <div className="flex items-start gap-1 text-gray-600">
                                                                <MdOutlinePayments className="mt-0.5 shrink-0 text-sm text-gray-400" />
                                                                <span className="break-all">Pay: {item.paymentNo}</span>
                                                            </div>
                                                        }
                                                        {item.paymentDetails &&
                                                            <div className="flex items-start gap-1 text-gray-600">
                                                                <MdOutlinePayments className="mt-0.5 shrink-0 text-sm text-gray-400" />
                                                                <span className="break-words">{item.paymentDetails}</span>
                                                            </div>
                                                        }
                                                        {item.rechargeContactName &&
                                                            <div className="flex items-start gap-1 text-gray-600">
                                                                <MdOutlinePerson className="mt-0.5 shrink-0 text-sm text-gray-400" />
                                                                <span>{item.rechargeContactName}</span>
                                                            </div>
                                                        }
                                                        {item.rechargeContactNo &&
                                                            <div className="flex items-start gap-1 text-gray-600">
                                                                <MdOutlinePhone className="mt-0.5 shrink-0 text-sm text-gray-400" />
                                                                <span>{item.rechargeContactNo}</span>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </>
                                ) : (
                                    <Empty>No Items Found.</Empty>
                                )
                            ) : (
                                <LoadingContainer />
                            )}
                        </Paging>
                    </div>
                </Card>
            </div>
        </Container>
    )
}